/* FineRoot front-end. Dual-mode cart + page interactions.
   Static preview: a local cart kept in localStorage. Theme mode (window.FR_THEME): native Shopify cart AJAX,
   product + selling plan printed by Liquid as window.FR_PRODUCT (never hardcoded ids). */
(function () {
  "use strict";

  var THEME = !!window.FR_THEME;
  var ASSET = window.FR_ASSET_BASE || "assets/";
  var CART_KEY = "frCart";
  var TYPE = "Turmeric";
  var money = function (v) { return "$" + (Math.round(v * 100) / 100).toFixed(2); };
  var r2 = function (v) { return Math.round(v * 100) / 100; };

  // Same maths Shopify runs: automatic "Amount off products" discounts, fixed dollars once per order,
  // by bottle count. Keep in step with content.py LADDER + SHOPIFY-SETUP.md (live on the store).
  var LADDER = [{ min: 5, off: 59.98 }, { min: 3, off: 29.99 }];
  function rung(q) { for (var i = 0; i < LADDER.length; i++) if (q >= LADDER[i].min) return LADDER[i]; return null; }

  var PRODUCT = window.FR_PRODUCT || {
    title: "Pure Curcumin Turmeric Capsules", handle: "pure-curcumin-turmeric-capsules",
    variant: { id: "local-1", price: 29.99, available: true, inventory: null },
    plan: { id: "local-sub", pct: 20 }
  };
  var PRICE = PRODUCT.variant.price;
  var PLAN = PRODUCT.plan || null; // null when no subscription app / selling plan exists: the toggle hides

  function unitFor(sub) { return sub && PLAN ? r2(PRICE * (1 - PLAN.pct / 100)) : PRICE; }
  function totalFor(q, sub) {
    var line = r2(unitFor(sub) * q), rg = rung(q);
    return rg ? r2(line - Math.min(rg.off, line)) : line;
  }

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };

  // ---------------------------------------------------------- promo countdown (one real end time for everyone)
  var promo = $("[data-promo]");
  if (promo) {
    var end = Date.parse(promo.getAttribute("data-end"));
    var cdWrap = $("[data-countdown]", promo);
    var cdEl = { d: $("[data-cd-d]", promo), h: $("[data-cd-h]", promo), m: $("[data-cd-m]", promo), s: $("[data-cd-s]", promo) };
    var pad = function (n) { return (n < 10 ? "0" : "") + n; };
    var tick = function () {
      var ms = end - Date.now();
      if (!(ms > 0)) { cdWrap.hidden = true; return false; }
      var s = Math.floor(ms / 1000);
      cdEl.d.textContent = Math.floor(s / 86400); cdEl.h.textContent = pad(Math.floor(s % 86400 / 3600));
      cdEl.m.textContent = pad(Math.floor(s % 3600 / 60)); cdEl.s.textContent = pad(s % 60);
      cdWrap.hidden = false;
      return true;
    };
    if (tick()) { var cdTimer = setInterval(function () { if (!tick()) clearInterval(cdTimer); }, 1000); }
  }

  // ---------------------------------------------------------- cart backends
  function localRead() { try { return JSON.parse(localStorage.getItem(CART_KEY) || "[]"); } catch (e) { return []; } }
  function localWrite(lines) { try { localStorage.setItem(CART_KEY, JSON.stringify(lines)); } catch (e) {} return Promise.resolve({ lines: lines }); }
  var backend = {
    fetch: function () { return Promise.resolve({ lines: localRead() }); },
    add: function (items) {
      var lines = localRead();
      items.forEach(function (it) {
        var sub = !!it.selling_plan, key = String(it.id) + (sub ? ":sub" : "");
        var hit = lines.filter(function (l) { return l.lineId === key; })[0];
        if (hit) hit.qty += it.quantity;
        else lines.push({ lineId: key, qty: it.quantity, sub: sub, price: unitFor(sub), title: PRODUCT.title, type: TYPE });
      });
      return localWrite(lines);
    },
    change: function (lineId, qty) {
      return localWrite(localRead().filter(function (l) { if (l.lineId === lineId) l.qty = qty; return l.qty > 0; }));
    }
  };

  if (THEME) {
    // Shopify re-keys a cart line when its discount changes (crossing a bundle tier), so a queued
    // change must resolve the line's CURRENT key from the latest cart, matched by variant + plan.
    var lastItems = [];
    var resolveKey = function (key, ref) {
      if (lastItems.some(function (i) { return i.key === key; })) return key;
      var hit = ref && lastItems.filter(function (i) {
        return i.variant_id === ref.variantId && ((i.selling_plan_allocation && i.selling_plan_allocation.selling_plan.id) || null) === (ref.plan || null);
      })[0];
      return hit ? hit.key : key;
    };
    var mapNative = function (c) {
      lastItems = c.items || [];
      return { total: c.total_price / 100, orig: (c.original_total_price || c.total_price) / 100, lines: (c.items || []).map(function (it) {
        return { lineId: String(it.key), qty: it.quantity, sub: !!it.selling_plan_allocation,
                 price: it.price / 100, title: it.product_title, type: it.product_type, image: it.image,
                 variantId: it.variant_id, plan: it.selling_plan_allocation ? it.selling_plan_allocation.selling_plan.id : null };
      }) };
    };
    var nativeJson = function (url, body) {
      return fetch(url, {
        method: body ? "POST" : "GET",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: body ? JSON.stringify(body) : undefined
      }).then(function (r) { if (!r.ok) throw new Error("cart request failed " + r.status); return r.json(); });
    };
    backend = {
      fetch: function () { return nativeJson("/cart.js").then(mapNative); },
      add: function (items) { return nativeJson("/cart/add.js", { items: items }).then(function () { return backend.fetch(); }); },
      change: function (lineId, qty, ref) { return nativeJson("/cart/change.js", { id: resolveKey(lineId, ref), quantity: qty }).then(mapNative); }
    };
  }

  // ---------------------------------------------------------- cart logic
  var cart = { lines: [] };
  function bottleLines() { return cart.lines.filter(function (l) { return l.type === TYPE; }); }
  function bottleQty() { return bottleLines().reduce(function (a, l) { return a + l.qty; }, 0); }

  function renderCart() {
    var root = $("[data-cart]");
    if (!root) return;
    var lines = cart.lines;
    var count = lines.reduce(function (a, l) { return a + l.qty; }, 0);
    var badge = $("[data-cart-count]");
    if (badge) { badge.textContent = count; badge.hidden = count === 0; }
    $("[data-cart-empty]").hidden = count > 0;
    $("[data-cart-foot]").hidden = count === 0;

    var box = $("[data-cart-lines]");
    box.innerHTML = "";
    lines.forEach(function (l) {
      var row = document.createElement("div");
      row.className = "fr-line";
      var im = l.type === TYPE ? ASSET + "fr-bottle-480.webp" : (l.image || ASSET + "fr-bottle-480.webp");
      row.innerHTML =
        '<img src="' + im + '" width="72" height="72" alt="">' +
        '<span><span class="fr-line__t">' + (l.type === TYPE ? "Pure Curcumin Turmeric" : l.title) + "</span>" +
        (l.type === TYPE ? '<span class="fr-line__v' + (l.sub ? ' fr-line__v--sub">Subscribe &amp; Save &middot; Monthly' : '">One-time purchase') + "</span>" : "") +
        '<span class="fr-line__qty"><button type="button" data-dec aria-label="Decrease quantity">&minus;</button><span>' + l.qty + '</span><button type="button" data-inc aria-label="Increase quantity">+</button></span></span>' +
        '<span><span class="fr-line__p">' + money(l.price * l.qty) + '</span><button class="fr-line__rm" type="button" data-rm>Remove</button></span>';
      row.querySelector("[data-inc]").addEventListener("click", function () { changeQty(l, l.qty + 1); });
      row.querySelector("[data-dec]").addEventListener("click", function () { changeQty(l, l.qty - 1); });
      row.querySelector("[data-rm]").addEventListener("click", function () { changeQty(l, 0); });
      box.appendChild(row);
    });

    var q = bottleQty();
    var nudge = $("[data-cart-nudge]");
    var need = q > 0 && q < 3 ? 3 - q : q >= 3 && q < 5 ? 5 - q : 0;
    nudge.hidden = !need;
    if (need) {
      $("[data-cart-nudge-text]").textContent = q < 3
        ? "Add " + need + " more bottle" + (need > 1 ? "s" : "") + " and 1 is free."
        : "Add " + need + " more and 2 bottles are free.";
      $("[data-cart-nudge-add]").textContent = "Add " + need;
      nudge.setAttribute("data-need", need);
    }

    var subtotal = lines.reduce(function (a, l) { return a + l.price * l.qty; }, 0);
    var rg = rung(q), sv = 0;
    if (cart.total != null) {
      // theme mode: Shopify's own numbers, so the drawer always matches checkout
      subtotal = cart.orig; sv = r2(cart.orig - cart.total);
    } else {
      if (rg) sv = r2(Math.min(rg.off, bottleLines().reduce(function (a, l) { return a + l.price * l.qty; }, 0)));
    }
    $("[data-cart-savings]").hidden = !sv;
    if (sv) $("[data-cart-savings-amt]").textContent = "−" + money(sv);
    $("[data-cart-subtotal]").textContent = money(subtotal - sv);
  }

  function busy(el, on) { if (!el) return; el.disabled = on; el.style.opacity = on ? ".55" : ""; }

  // Optimistic + queued: the drawer updates instantly, requests go one at a time, the server's answer is
  // only painted once nothing else is waiting, so fast double taps are never lost.
  var cartQueue = Promise.resolve(), cartPending = 0;
  function changeQty(line, qty) {
    qty = Math.max(0, qty);
    cart.lines = cart.lines.filter(function (l) { if (l.lineId === line.lineId) l.qty = qty; return l.qty > 0; });
    cart.total = null;
    renderCart();
    cartPending++;
    var ref = { variantId: line.variantId, plan: line.plan };
    cartQueue = cartQueue.then(function () { return backend.change(line.lineId, qty, ref); })
      .then(function (c) { cartPending--; if (cartPending === 0 && c) { cart = c; renderCart(); } })
      .catch(function () { cartPending--; if (cartPending === 0) syncCart(); });
  }

  var nudgeBtn = $("[data-cart-nudge-add]");
  if (nudgeBtn) nudgeBtn.addEventListener("click", function () {
    var first = bottleLines()[0], need = +$("[data-cart-nudge]").getAttribute("data-need") || 1;
    if (first) changeQty(first, first.qty + need);
  });

  function lock(on) { document.documentElement.style.overflow = on ? "hidden" : ""; }
  function openPanel(root) { if (!root) return; root.hidden = false; requestAnimationFrame(function () { root.classList.add("is-open"); }); lock(true); }
  function closePanel(root) { if (!root || root.hidden) return; root.classList.remove("is-open"); lock(false); setTimeout(function () { root.hidden = true; }, 300); }
  var openCart = function () { openPanel($("[data-cart]")); };
  var closeCart = function () { closePanel($("[data-cart]")); };
  var openMenu = function () { openPanel($("[data-drawer]")); };
  var closeMenu = function () { closePanel($("[data-drawer]")); };

  function checkout() {
    var btn = $("[data-cart-checkout]");
    if (THEME) { busy(btn, true); window.location.href = "/checkout"; return; }
    var note = $("[data-cart-preview-note]");
    if (note) { note.hidden = false; note.textContent = "Preview build. Checkout goes live once the theme is on your Shopify store."; }
  }

  $$("[data-drawer-open]").forEach(function (b) { b.addEventListener("click", openMenu); });
  $$("[data-drawer-close]").forEach(function (b) { b.addEventListener("click", closeMenu); });
  $$("[data-cart-open]").forEach(function (b) { b.addEventListener("click", openCart); });
  $$("[data-cart-close]").forEach(function (b) { b.addEventListener("click", closeCart); });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") { closeMenu(); closeCart(); } });
  var co = $("[data-cart-checkout]");
  if (co) co.addEventListener("click", checkout);

  // ---------------------------------------------------------- reveal
  if (document.documentElement.className.indexOf("js-anim") !== -1 && "IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add("is-in"); io.unobserve(en.target); } });
    }, { rootMargin: "0px 0px -6% 0px" });
    $$(".fr-rise").forEach(function (el) { io.observe(el); });
  } else {
    $$(".fr-rise").forEach(function (el) { el.classList.add("is-in"); });
  }

  // ---------------------------------------------------------- PDP
  var buy = $("[data-buy]");
  if (buy) {
    var LABEL = { 1: "1 Bottle", 3: "Buy 2, Get 1 Free", 5: "Buy 3, Get 2 Free" };
    if (!PLAN) { var pb = $("[data-plan-box]"); if (pb) pb.hidden = true; }
    var selectedTier = function () { var r = $("[data-tier]:checked"); return r ? parseInt(r.value, 10) : 3; };
    var isSub = function () { var r = $('[data-plan][value="sub"]'); return !!(PLAN && r && r.checked); };

    // Subscribe & Save is one bottle delivered monthly; bundles are one-time. Picking one moves the other.
    var syncPlan = function (e) {
      if (!PLAN || !e) return;
      if (e.target.matches("[data-plan]") && isSub()) $('[data-tier][value="1"]').checked = true;
      if (e.target.matches("[data-tier]") && selectedTier() > 1 && isSub()) $('[data-plan][value="once"]').checked = true;
    };
    var updatePrice = function (e) {
      syncPlan(e);
      var sub = isSub();
      $$("[data-tier]").forEach(function (r) {
        var q = parseInt(r.value, 10), row = r.closest(".fr-tier"), t = totalFor(q, sub && q === 1);
        $("[data-tier-price]", row).textContent = money(t);
        $("[data-each]", row).textContent = money(Math.floor(t / q * 100) / 100);
        var dd = $("[data-day]", row); if (dd) dd.textContent = money(t / (30 * q)) + "/day";
      });
      var total = totalFor(selectedTier(), sub);
      $("[data-cta-price]").textContent = money(total) + (sub ? "/mo" : "");
      var was = $("[data-cta-was]"), rowWas = $("[data-tier-was]", $("[data-tier]:checked").closest(".fr-tier"));
      if (was && rowWas) was.textContent = rowWas.textContent;
      var sp = $("[data-sticky-price]"); if (sp) sp.textContent = money(total);
      var ss = $("[data-sticky-sub]"); if (ss) ss.textContent = LABEL[selectedTier()] + (sub ? " · Monthly" : "");
    };
    $$("[data-tier],[data-plan]").forEach(function (r) { r.addEventListener("change", updatePrice); });

    var showImg = function (key) {
      $$("[data-gal-img]").forEach(function (im) { im.hidden = im.getAttribute("data-gal-img") !== key; });
      $$("[data-gal-thumb]").forEach(function (t) {
        var on = t.getAttribute("data-gal-thumb") === key;
        t.setAttribute("aria-selected", String(on));
        var strip = t.parentNode;
        if (on && strip.scrollWidth > strip.clientWidth) {
          strip.scrollTo({ left: t.offsetLeft - strip.offsetLeft - (strip.clientWidth - t.offsetWidth) / 2, behavior: "smooth" });
        }
      });
    };
    $$("[data-gal-thumb]").forEach(function (t) { t.addEventListener("click", function () { showImg(t.getAttribute("data-gal-thumb")); }); });

    // Gallery photos must swap instantly, back and forth. Hidden slides stay lazy for the first paint (LCP),
    // then download quietly once the page is idle; a finger or cursor on a thumb fetches that one at once.
    var warmImg = function (key) {
      var im = $('[data-gal-img="' + key + '"]');
      if (im && im.loading === "lazy") { im.loading = "eager"; if (im.decode) im.decode().catch(function () {}); }
    };
    var warmAll = function () { $$("[data-gal-thumb]").forEach(function (t) { warmImg(t.getAttribute("data-gal-thumb")); }); };
    $$("[data-gal-thumb]").forEach(function (t) {
      var go = function () { warmImg(t.getAttribute("data-gal-thumb")); };
      t.addEventListener("touchstart", go, { passive: true });
      t.addEventListener("mouseenter", go);
      t.addEventListener("focus", go);
    });
    var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 1200); };
    if (document.readyState === "complete") idle(warmAll); else window.addEventListener("load", function () { idle(warmAll); });

    // deep links: ?qty=1|3|5 and ?plan=sub
    try {
      var params = new URLSearchParams(location.search);
      var qq = params.get("qty");
      if (qq) { var radio = $('[data-tier][value="' + parseInt(qq, 10) + '"]'); if (radio) radio.checked = true; }
      if (params.get("plan") === "sub" && PLAN) { $('[data-plan][value="sub"]').checked = true; $('[data-tier][value="1"]').checked = true; }
    } catch (e) {}
    updatePrice();

    var addToCart = function () {
      var btn = $("[data-add-to-cart]"), err = $("[data-cart-error]");
      err.hidden = true;
      if (btn.disabled) return;
      if (PRODUCT.variant.available === false) {
        err.textContent = "Sold out right now. Join the list below and we email you the moment it is back.";
        err.hidden = false; return;
      }
      var item = { id: THEME ? parseInt(PRODUCT.variant.id, 10) : PRODUCT.variant.id, quantity: selectedTier() };
      if (isSub()) item.selling_plan = THEME ? parseInt(PLAN.id, 10) : PLAN.id;
      var btns = [btn, $("[data-sticky-go]")].filter(Boolean);
      var label = function (on) {
        btns.forEach(function (b) {
          if (on) { b.setAttribute("data-label", b.innerHTML); b.textContent = "Adding…"; }
          else if (b.hasAttribute("data-label")) { b.innerHTML = b.getAttribute("data-label"); b.removeAttribute("data-label"); }
          busy(b, on);
        });
      };
      label(true);
      backend.add([item]).then(function (c) {
        cart = c; label(false); updatePrice(); renderCart(); openCart();
      }).catch(function () {
        label(false);
        err.textContent = "Could not reach the store just now. Give it a second and try again.";
        err.hidden = false;
      });
    };
    $("[data-add-to-cart]").addEventListener("click", addToCart);
    var sg = $("[data-sticky-go]");
    if (sg) sg.addEventListener("click", addToCart);

    // lightbox: click the main image to zoom, arrows / keys to move
    var lb = $("[data-lb]");
    if (lb) {
      var keys = $$("[data-gal-thumb]").map(function (t) { return t.getAttribute("data-gal-thumb"); });
      var cur = 0;
      var lbShow = function (i) {
        cur = (i + keys.length) % keys.length;
        var src = $('[data-gal-img="' + keys[cur] + '"]'), big = $("[data-lb-img]");
        big.src = src.currentSrc || src.getAttribute("src"); big.alt = src.alt;
      };
      var lbClose = function () { lb.classList.remove("is-open"); lock(false); setTimeout(function () { lb.hidden = true; }, 250); };
      $("[data-gal-zoom]").addEventListener("click", function () {
        var vis = $$("[data-gal-img]").filter(function (im) { return !im.hidden; })[0];
        lbShow(keys.indexOf(vis.getAttribute("data-gal-img")));
        lb.hidden = false; lock(true);
        requestAnimationFrame(function () { lb.classList.add("is-open"); });
      });
      $("[data-lb-close]").addEventListener("click", lbClose);
      $("[data-lb-prev]").addEventListener("click", function (e) { e.stopPropagation(); lbShow(cur - 1); });
      $("[data-lb-next]").addEventListener("click", function (e) { e.stopPropagation(); lbShow(cur + 1); });
      lb.addEventListener("click", function (e) { if (e.target === lb) lbClose(); });
      document.addEventListener("keydown", function (e) {
        if (lb.hidden) return;
        if (e.key === "Escape") lbClose();
        if (e.key === "ArrowLeft") lbShow(cur - 1);
        if (e.key === "ArrowRight") lbShow(cur + 1);
      });
    }

    // sticky bar: on only after the main button has scrolled above the screen (scroll-driven, not IO)
    var sticky = $("[data-sticky]"), mainBtn = $("[data-add-to-cart]");
    if (sticky) {
      var ticking = false;
      var syncSticky = function () { ticking = false; sticky.classList.toggle("is-on", mainBtn.getBoundingClientRect().bottom < 0); };
      window.addEventListener("scroll", function () { if (!ticking) { ticking = true; requestAnimationFrame(syncSticky); } }, { passive: true });
      syncSticky();
    }
  }

  // ---------------------------------------------------------- load cart
  var syncCart = function () { return backend.fetch().then(function (c) { cart = c; renderCart(); }).catch(function () {}); };
  syncCart();
  window.addEventListener("pageshow", function (e) {
    if (!e.persisted) return;
    closeCart(); closeMenu(); lock(false);
    $$("[data-add-to-cart],[data-sticky-go],[data-cart-checkout]").forEach(function (b) {
      if (b.hasAttribute("data-label")) { b.innerHTML = b.getAttribute("data-label"); b.removeAttribute("data-label"); }
      busy(b, false);
    });
    syncCart();
  });

  // warm the next page the moment a finger or cursor lands on an internal link
  var warmed = {};
  var warm = function (e) {
    var a = e.target.closest && e.target.closest("a[href]");
    if (!a || a.origin !== location.origin || warmed[a.pathname] || a.pathname === location.pathname) return;
    warmed[a.pathname] = 1;
    var l = document.createElement("link"); l.rel = "prefetch"; l.href = a.pathname + a.search; document.head.appendChild(l);
  };
  document.addEventListener("touchstart", warm, { passive: true });
  document.addEventListener("mouseover", warm, { passive: true });

  // ---------------------------------------------------------- forms (static preview only; the theme uses native Shopify forms)
  function wireCapture(formSel, noteSel) {
    var f = $(formSel);
    if (!f) return;
    f.addEventListener("submit", function (e) {
      e.preventDefault();
      var input = f.querySelector("input[type=email]"), note = $(noteSel);
      var ok = input.value && input.value.indexOf("@") > 0;
      note.textContent = ok ? "You're on the list. Welcome to FineRoot." : "That email looks off. One more try?";
      note.hidden = false;
      if (ok) input.value = "";
    });
  }
  wireCapture("[data-capture]", "[data-capture-note]");
  wireCapture("[data-capture-2]", "[data-capture-2-note]");

  var contact = $("[data-contact]");
  if (contact) {
    contact.addEventListener("submit", function (e) {
      e.preventDefault();
      var fd = new FormData(contact), note = $("[data-contact-note]");
      var ok = fd.get("name") && fd.get("email") && fd.get("message");
      note.textContent = ok ? "Thanks. A real person answers within one business day." : "Fill in your name, email and message and we take it from there.";
      note.hidden = false;
      if (ok) contact.reset();
    });
  }
})();
